module.exports = __webpack_public_path__ + "static/media/noun_Smartphone_409470.2683a981.svg";